import React, { useContext } from 'react';
import useInput from '../../../hooks/useInput';
import { GlobalSettingsContext } from '../../../contexts/globalSettings';
import get from 'lodash/get';
// import useLocalStorage from '../../../hooks/useLocalStorage';

function SettingsTab() {
  const { info, setInfo } = useContext(GlobalSettingsContext);
  // const [darkMode, setDarkMode] = useLocalStorage('darkMode', 'false');
  // const { value: uniquePageLimit, setValue: setuniquePageLimit, reset: resetPageLimit } = useInput(null);

  // const setActiveTabs = key => event => {
  //   if (event.target.checked) {
  //     setInfo({
  //       activeTabs: [...info.activeTabs, key]
  //     });
  //   } else {
  //     setInfo({
  //       activeTabs: info.activeTabs.filter(activeTab => activeTab !== key)
  //     });
  //   }

  // };

  // const resetData = () => {
  //   setInfo(null);
  //   resetPageLimit();
  // };

  // const updateUniqueLimit = key => event => {
  //   let currentInfo = { ...info };
  //   setuniquePageLimit(event.target.value);
  //   setInfo({
  //     sessionInfo: Object.assign({}, currentInfo.sessionInfo, {
  //       uniquePageLimit: parseInt(event.target.value),
  //     }),
  //   });
  // };

  // const setDarkMode = (value) => {
  //   setInfo({
  //     darkMode: value
  //   });
  // }

  const togglePersistent = (value) => {
    setInfo({
      isPersistent: !value
    });
  }

  return (
    <div>
      <div style={{ display: 'flex', border: '1px dashed #ccc' }}>
        {/* <p>
          <input
            type="checkbox"
            id="Analytics-toggle"
            name="Analytics-toggle"
            value={info.darkMode}
            checked={info.activeTabs.includes('analytics')}
            onClick={setActiveTabs("analytics")}
          />&nbsp;
          <label htmlFor="Analytics-toggle">Analytics</label>
        </p> */}
        {/* <p>
          <input
            type="checkbox"
            id="History-toggle"
            name="History-toggle"
            value={info.darkMode}
            checked={info.activeTabs.includes('history')}
            onClick={setActiveTabs("history")}
          />&nbsp;
          <label htmlFor="History-toggle">History</label>
        </p> */}
        {/* <p>
          <input
            type="checkbox"
            id="Page-toggle"
            name="Page-toggle"
            value={info.darkMode}
            checked={info.activeTabs.includes('page')}
            onClick={setActiveTabs("page")}
          />&nbsp;
          <label htmlFor="Page-toggle">Page</label>
        </p> */}
      </div>
      <p>
        <label htmlFor="is-rersistent-toggle">Is Persistent?</label>&nbsp;
        <input
          type="checkbox"
          id="Persistent-toggle"
          name="Persistent-toggle"
          value={info.isPersistent}
          checked={info.isPersistent}
          onClick={() => {togglePersistent(info.isPersistent)}}
        />
      </p>
      {/* <p>
        <label htmlFor="dark-mode-toggle">Dark mode?</label>&nbsp;
        <input
          type="checkbox"
          id="dark-mode-toggle"
          name="dark-mode-toggle"
          value={info.darkMode}
          checked={info.darkMode}
          onClick={() => { setDarkMode(!info.darkMode); }}
        />
      </p> */}
      {/* <p>
        <label htmlFor="data-reset-toggle">Reset?!</label>&nbsp;
        <button id="data-reset-toggle" name="data-reset-toggle" onClick={resetData}>X</button>
      </p> */}
      {/* <p>
        <label htmlFor="data-page-view-limit">Unique Page Limit</label>&nbsp;
        <input
          name="data-page-view-limit"
          type="text"
          placeholder="An integer value of max views"
          value={uniquePageLimit}
          onChange={updateUniqueLimit('sessionInfo')} />
      </p> */}
    </div>
  );
}

export default SettingsTab;